<script setup lang="ts">
import Avatar from '@/features/avatar/Avatar.vue';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { useGlobalStore } from '@/stores/global';

const { toggleDrawer } = useGlobalStore();
const { auth } = useMeQuery();
</script>

<template>
  <v-btn class="text-none" icon @click="toggleDrawer">
    <Avatar img-size="thumb" :branding="auth?.branding" />
  </v-btn>
</template>
